import { QuestQueryParamsEnum, SocialAccountQueryParamsEnum } from '../types/enums';
import { deleteUrlParam } from '@/js/helpers/urlUtils';
import { showToast } from '@/js/helpers/toastHelpers';
import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
import { SocialNetworkEnum } from '../../dashboard/types/enums';
import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
import { dashboardRoutesPaths } from '../../dashboard/constants/dashboardRoutesPaths';
import { questsRoutes } from '@/js/constants/questsRoutes';
import { useQuestRoundDataStore } from '@/js/store/quests/game/modules/QuestRoundDataStore';
import { getTrans } from '@/js/helpers/getTrans';
import { isMetaMaskAppBrowser } from '@/js/auth/helpers/deviceUtils';

export const deleteAuthTypeQueryParam = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const authType = queryParams.get(QuestQueryParamsEnum.TYPE);

    if (authType) {
        deleteUrlParam(QuestQueryParamsEnum.TYPE, queryParams);
    }
};

export const handleSocialAccountQueryParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const socialConnectError = queryParams.get(SocialAccountQueryParamsEnum.ERROR);
    const isSocialConnected = queryParams.get(SocialAccountQueryParamsEnum.SOCIAL_CONNECTED);
    const isSocialAccountPrimary = queryParams.get(SocialAccountQueryParamsEnum.IS_PRIMARY);
    const socialNetwork = queryParams.get(SocialAccountQueryParamsEnum.SOCIAL_NETWORK);

    if (socialConnectError) {
        const modalStore = useModalStore();
        modalStore.toggleModal(ModalEnum.SOCIAL_ACCOUNT_ERROR, true);

        return;
    }

    if (isSocialConnected) {
        if (!isMetaMaskAppBrowser()) {
            deleteUrlParam(SocialAccountQueryParamsEnum.SOCIAL_CONNECTED, queryParams);
            deleteUrlParam(SocialAccountQueryParamsEnum.IS_PRIMARY, queryParams);
        }

        const isOgvioNetwork = socialNetwork === SocialNetworkEnum.OGVIO;
        const successMessage = isOgvioNetwork
            ? getTrans('ogvioAccountConnected', 'Your Ogvio account connected successfully.')
            : getTrans('userSocialConnected', 'Your new social account connected successfully.');

        showToast({
            type: 'success',
            message: successMessage,
        });

        // Don't show "Make Primary" modal for Ogvio accounts since only one account is allowed
        if (isSocialAccountPrimary === 'false' && !isOgvioNetwork) {
            const path = window.location.pathname;
            const modalStore = useModalStore();

            if (path === dashboardRoutesPaths.SETTINGS_ROUTE_PATH) {
                const userStore = useUserStore();

                userStore.selectedSocialAccount = {
                    user_name: isSocialConnected,
                    social_network: socialNetwork as SocialNetworkEnum,
                    is_primary: false,
                };

                modalStore.toggleModal(ModalEnum.CONNECTED_SOCIAL_ACCOUNT, true);
            }

            if (path === questsRoutes.MISSION_ROUTE) {
                const questRoundDataStore = useQuestRoundDataStore();

                questRoundDataStore.userProfile.selectedSocialAccount = {
                    user_name: isSocialConnected,
                    social_network: socialNetwork as SocialNetworkEnum,
                    is_primary: false,
                };

                modalStore.toggleModal(ModalEnum.CONNECTED_SOCIAL_ACCOUNT, true);
            }
        }
    }
};

export const handleRegistrationErrorQueryParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const error = queryParams.get(SocialAccountQueryParamsEnum.ERROR);
    const socialNetwork = queryParams.get(SocialAccountQueryParamsEnum.SOCIAL_NETWORK);

    if (error) {
        if (!isMetaMaskAppBrowser()) {
            deleteUrlParam(SocialAccountQueryParamsEnum.ERROR, queryParams);
            deleteUrlParam(SocialAccountQueryParamsEnum.SOCIAL_NETWORK, queryParams);
        }

        let errorMessage: string;
        if (error === 'access_denied' && socialNetwork === 'ogvio') {
            errorMessage = getTrans('ogvioRegistrationCancelled', 'Authentication with Ogvio was cancelled.');
        } else {
            errorMessage = getTrans('registrationError', 'An error occurred. Please try again.');
        }

        showToast({
            type: 'error',
            message: errorMessage,
        });
    }
};
